module.exports = __webpack_public_path__ + "img/hamburger.29230556.svg";